<template>
    <div
        class="d-flex flex-column fill-width"
        :class="{
            'text-block-overlay-light pa-2': config.showUnderlay
        }"
    >
        <!-- Title -->
        <h4
            v-if="config.title.content"
            class="text-h4 content-block-text-title font-weight-bold text-uppercase px-2"
            :class="{
                'mb-2': config.subTitle?.content
            }"
            v-html="config.title.content"
        ></h4>

        <!-- Subtitle -->
        <h5
            v-if="config.subTitle?.content"
            class="text-h5 content-block-text-subtitle px-2"
            :class="{
                'mb-2': config.body?.content
            }"
            v-html="config.subTitle.content"
        ></h5>

        <!-- Body Text -->
        <div
            v-if="config.body?.content"
            class="content-block-text-body px-2"
            v-html="config.body.content"
        ></div>

        <!-- Buttons -->
        <div
            v-if="!!config.buttons.items.length"
            class="d-flex flex-row flex-wrap"
            :class="[
                config.buttonsCssClass ?? 'justify-center',
                {
                    'mt-2': !!config.body?.content
                }
            ]"
        >
            <template
                v-for="(btn, index) in config.buttons.items"
                :key="`block-type-text-btn-${index}`"
            >
                <BtnUniversal
                    :params="btn"
                    :is-nested-link="isHyperlinkBlock"
                    class="secondary ma-2"
                    :class="btn.theme[theme].cssClass"
                    :style="btn.theme[theme].cssStyle"
                >
                    {{ btn.content }}
                </BtnUniversal>
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import type {
        ContentBlocksComponentProps,
        ContentBlockText
    } from '~/types';
    import BtnUniversal from '~/components/BtnUniversal/BtnUniversal.vue';

    withDefaults(
        defineProps<ContentBlocksComponentProps<ContentBlockText>>(),
        {
            theme: 'light',
            breakpoint: 'desktop',
            breakpointName: 'md'
        }
    );
</script>

<style lang="scss" scoped></style>
